<template>
  <el-dialog
    title="视频轮巡设置"
    :visible="modalOpen"
    :append-to-body="true"
    width="1000px"
    :before-close="handleModalCancel"
  >
    <div class="modify-video-patrol">
      <div class="modify-video-patrol container-with-collapsible-tree-sidebar">
        <!--侧边栏-->
        <div class="tree-side-bar">
          <div class="general-container">
            <el-input class="search-input"
                      v-model="treeNodeFilter"
                      placeholder="请输入视频节点名称"
                      clearable>
              <img slot="prefix" src="@/assets/img/icon_search.png">
            </el-input>
          </div>
          <el-tree
            :data="treeData"
            ref="tree"
            node-key="key"
            :props="defaultTreeProps"
            :default-expanded-keys="treeExpandedKeys"
            :default-checked-keys="checkedKeys"
            show-checkbox
            highlight-current
            :filter-node-method="filterTreeNode"
            @node-click="handleTreeNodeClick"
            @check="handleTreeNodeCheck"
          >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>
            <i class="tree-node-icon"
               :class="data.type === 'region' ? 'tree-node-icon-region'
               : streamNodeIconClassFromStreamObjectKindAndState(data.streamObjectKind, data.alarmState, data.eventTypeSet, data.workState)"></i>
            <span class="tree-node-label" :title="node.label">{{ node.label }}</span>
          </span>
        </span>
          </el-tree>
        </div>
        <div class="col-2">
          <div class="right-container">
          <div class="checked-stream-node-container">
            <div class="container-title">轮巡节点列表</div>
            <el-tree
              :data="checkedTreeData"
              :props="defaultTreeProps"
              node-key="key"
              default-expand-all>
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>
                  <i class="tree-node-icon" :class="data.type === 'region' ? 'tree-node-icon-region':
                  streamNodeIconClassFromStreamObjectKindAndState(data.streamObjectKind, data.alarmState, data.eventTypeSet, data.workState)"></i>
                  <span class="tree-node-label">{{ node.label }}</span>
                </span>
              </span>
            </el-tree>
          </div>
          <div class="info-container">
            <div class="container-title">统计信息</div>
            <div class="info-item">
              <p>视频节点总数</p>
              <p style="margin-bottom: 30px">共 <span>{{totalStreamNodeCount}}</span> 台</p>
              <p>已选中节点数</p>
              <p>共 <span>{{checkedTreeData.length}}</span> 台</p>
            </div>
            <div class="container-title">参数设置</div>
            <div class="info-item">
              <p>轮巡间隔时间（秒）</p>
              <el-input v-model="patrolInterval" placeholder="输入轮巡间隔"></el-input>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="startVideoPatrol" v-if="!videoPatrolActive">开始轮巡</el-button>
      <el-button @click="stopVideoPatrol" v-else="">停止轮巡</el-button>
      <el-button @click="handleModalCancel">关闭窗口</el-button>
    </div>
  </el-dialog>
</template>

<script type="text/ecmascript-6">
import ModifyVideoPatrol from './ModifyVideoPatrol.js'
export default ModifyVideoPatrol
</script>

<style lang="scss">
@import "ModifyVideoPatrol";
</style>



// WEBPACK FOOTER //
// src/views/monitoring/liveVideo/modifyVideoPatrol/ModifyVideoPatrol.vue